/**
 * Generiamo un id per la conferma email
 * la funzione centralizza la gestione del nome differente
 */
export function metadataSuffix(id: string, type: SuffixType): string {
  return id + type;
}

export enum SuffixType {
  Confirm = '-confirm'
}
